var map = {
	"./square/ac.svg": 1763,
	"./square/ad.svg": 1764,
	"./square/ae.svg": 1765,
	"./square/af.svg": 1766,
	"./square/ag.svg": 1767,
	"./square/ai.svg": 1768,
	"./square/al.svg": 1769,
	"./square/am.svg": 1770,
	"./square/ao.svg": 1771,
	"./square/aq.svg": 1772,
	"./square/ar.svg": 1773,
	"./square/as.svg": 1774,
	"./square/at.svg": 1775,
	"./square/au.svg": 1776,
	"./square/aw.svg": 1777,
	"./square/ax.svg": 1778,
	"./square/az.svg": 1779,
	"./square/ba.svg": 1780,
	"./square/bb.svg": 1781,
	"./square/bd.svg": 1782,
	"./square/be.svg": 1783,
	"./square/bf.svg": 1784,
	"./square/bg.svg": 1785,
	"./square/bh.svg": 1786,
	"./square/bi.svg": 1787,
	"./square/bj.svg": 1788,
	"./square/bl.svg": 1789,
	"./square/bm.svg": 1790,
	"./square/bn.svg": 1791,
	"./square/bo.svg": 1792,
	"./square/bq.svg": 1793,
	"./square/br.svg": 1794,
	"./square/bs.svg": 1795,
	"./square/bt.svg": 1796,
	"./square/bv.svg": 1797,
	"./square/bw.svg": 1798,
	"./square/by.svg": 1799,
	"./square/bz.svg": 1800,
	"./square/ca.svg": 1801,
	"./square/cc.svg": 1802,
	"./square/cd.svg": 1803,
	"./square/cefta.svg": 1804,
	"./square/cf.svg": 1805,
	"./square/cg.svg": 1806,
	"./square/ch.svg": 1807,
	"./square/ci.svg": 1808,
	"./square/ck.svg": 1809,
	"./square/cl.svg": 1810,
	"./square/cm.svg": 1811,
	"./square/cn.svg": 1812,
	"./square/co.svg": 1813,
	"./square/cp.svg": 1814,
	"./square/cr.svg": 1815,
	"./square/cu.svg": 1816,
	"./square/cv.svg": 1817,
	"./square/cw.svg": 1818,
	"./square/cx.svg": 1819,
	"./square/cy.svg": 1820,
	"./square/cz.svg": 1821,
	"./square/de.svg": 1822,
	"./square/dg.svg": 1823,
	"./square/dj.svg": 1824,
	"./square/dk.svg": 1825,
	"./square/dm.svg": 1826,
	"./square/do.svg": 1827,
	"./square/dz.svg": 1828,
	"./square/ea.svg": 1829,
	"./square/ec.svg": 1830,
	"./square/ee.svg": 1831,
	"./square/eg.svg": 1832,
	"./square/eh.svg": 1833,
	"./square/er.svg": 1834,
	"./square/es-ct.svg": 1835,
	"./square/es-ga.svg": 1836,
	"./square/es.svg": 1837,
	"./square/et.svg": 1838,
	"./square/eu.svg": 1839,
	"./square/fi.svg": 1840,
	"./square/fj.svg": 1841,
	"./square/fk.svg": 1842,
	"./square/fm.svg": 1843,
	"./square/fo.svg": 1844,
	"./square/fr.svg": 1845,
	"./square/ga.svg": 1846,
	"./square/gb-eng.svg": 1847,
	"./square/gb-nir.svg": 1848,
	"./square/gb-sct.svg": 1849,
	"./square/gb-wls.svg": 1850,
	"./square/gb.svg": 1851,
	"./square/gd.svg": 1852,
	"./square/ge.svg": 1853,
	"./square/gf.svg": 1854,
	"./square/gg.svg": 1855,
	"./square/gh.svg": 1856,
	"./square/gi.svg": 1857,
	"./square/gl.svg": 1858,
	"./square/gm.svg": 1859,
	"./square/gn.svg": 1860,
	"./square/gp.svg": 1861,
	"./square/gq.svg": 1862,
	"./square/gr.svg": 1863,
	"./square/gs.svg": 1864,
	"./square/gt.svg": 1865,
	"./square/gu.svg": 1866,
	"./square/gw.svg": 1867,
	"./square/gy.svg": 1868,
	"./square/hk.svg": 1869,
	"./square/hm.svg": 1870,
	"./square/hn.svg": 1871,
	"./square/hr.svg": 1872,
	"./square/ht.svg": 1873,
	"./square/hu.svg": 1874,
	"./square/ic.svg": 1875,
	"./square/id.svg": 1876,
	"./square/ie.svg": 1877,
	"./square/il.svg": 1878,
	"./square/im.svg": 1879,
	"./square/in.svg": 1880,
	"./square/io.svg": 1881,
	"./square/iq.svg": 1882,
	"./square/ir.svg": 1883,
	"./square/is.svg": 1884,
	"./square/it.svg": 1885,
	"./square/je.svg": 1886,
	"./square/jm.svg": 1887,
	"./square/jo.svg": 1888,
	"./square/jp.svg": 1889,
	"./square/ke.svg": 1890,
	"./square/kg.svg": 1891,
	"./square/kh.svg": 1892,
	"./square/ki.svg": 1893,
	"./square/km.svg": 1894,
	"./square/kn.svg": 1895,
	"./square/kp.svg": 1896,
	"./square/kr.svg": 1897,
	"./square/kw.svg": 1898,
	"./square/ky.svg": 1899,
	"./square/kz.svg": 1900,
	"./square/la.svg": 1901,
	"./square/lb.svg": 1902,
	"./square/lc.svg": 1903,
	"./square/li.svg": 1904,
	"./square/lk.svg": 1905,
	"./square/lr.svg": 1906,
	"./square/ls.svg": 1907,
	"./square/lt.svg": 1908,
	"./square/lu.svg": 1909,
	"./square/lv.svg": 1910,
	"./square/ly.svg": 1911,
	"./square/ma.svg": 1912,
	"./square/mc.svg": 1913,
	"./square/md.svg": 1914,
	"./square/me.svg": 1915,
	"./square/mf.svg": 1916,
	"./square/mg.svg": 1917,
	"./square/mh.svg": 1918,
	"./square/mk.svg": 1919,
	"./square/ml.svg": 1920,
	"./square/mm.svg": 1921,
	"./square/mn.svg": 1922,
	"./square/mo.svg": 1923,
	"./square/mp.svg": 1924,
	"./square/mq.svg": 1925,
	"./square/mr.svg": 1926,
	"./square/ms.svg": 1927,
	"./square/mt.svg": 1928,
	"./square/mu.svg": 1929,
	"./square/mv.svg": 1930,
	"./square/mw.svg": 1931,
	"./square/mx.svg": 1932,
	"./square/my.svg": 1933,
	"./square/mz.svg": 1934,
	"./square/na.svg": 1935,
	"./square/nc.svg": 1936,
	"./square/ne.svg": 1937,
	"./square/nf.svg": 1938,
	"./square/ng.svg": 1939,
	"./square/ni.svg": 1940,
	"./square/nl.svg": 1941,
	"./square/no.svg": 1942,
	"./square/np.svg": 1943,
	"./square/nr.svg": 1944,
	"./square/nu.svg": 1945,
	"./square/nz.svg": 1946,
	"./square/om.svg": 1947,
	"./square/pa.svg": 1948,
	"./square/pe.svg": 1949,
	"./square/pf.svg": 1950,
	"./square/pg.svg": 1951,
	"./square/ph.svg": 1952,
	"./square/pk.svg": 1953,
	"./square/pl.svg": 1954,
	"./square/pm.svg": 1955,
	"./square/pn.svg": 1956,
	"./square/pr.svg": 1957,
	"./square/ps.svg": 1958,
	"./square/pt.svg": 1959,
	"./square/pw.svg": 1960,
	"./square/py.svg": 1961,
	"./square/qa.svg": 1962,
	"./square/re.svg": 1963,
	"./square/ro.svg": 1964,
	"./square/rs.svg": 1965,
	"./square/ru.svg": 1966,
	"./square/rw.svg": 1967,
	"./square/sa.svg": 1968,
	"./square/sb.svg": 1969,
	"./square/sc.svg": 1970,
	"./square/sd.svg": 1971,
	"./square/se.svg": 1972,
	"./square/sg.svg": 1973,
	"./square/sh.svg": 1974,
	"./square/si.svg": 1975,
	"./square/sj.svg": 1976,
	"./square/sk.svg": 1977,
	"./square/sl.svg": 1978,
	"./square/sm.svg": 1979,
	"./square/sn.svg": 1980,
	"./square/so.svg": 1981,
	"./square/sr.svg": 1982,
	"./square/ss.svg": 1983,
	"./square/st.svg": 1984,
	"./square/sv.svg": 1985,
	"./square/sx.svg": 1986,
	"./square/sy.svg": 1987,
	"./square/sz.svg": 1988,
	"./square/ta.svg": 1989,
	"./square/tc.svg": 1990,
	"./square/td.svg": 1991,
	"./square/tf.svg": 1992,
	"./square/tg.svg": 1993,
	"./square/th.svg": 1994,
	"./square/tj.svg": 1995,
	"./square/tk.svg": 1996,
	"./square/tl.svg": 1997,
	"./square/tm.svg": 1998,
	"./square/tn.svg": 1999,
	"./square/to.svg": 2000,
	"./square/tr.svg": 2001,
	"./square/tt.svg": 2002,
	"./square/tv.svg": 2003,
	"./square/tw.svg": 2004,
	"./square/tz.svg": 2005,
	"./square/ua.svg": 2006,
	"./square/ug.svg": 2007,
	"./square/um.svg": 2008,
	"./square/un.svg": 2009,
	"./square/us.svg": 2010,
	"./square/uy.svg": 2011,
	"./square/uz.svg": 2012,
	"./square/va.svg": 2013,
	"./square/vc.svg": 2014,
	"./square/ve.svg": 2015,
	"./square/vg.svg": 2016,
	"./square/vi.svg": 2017,
	"./square/vn.svg": 2018,
	"./square/vu.svg": 2019,
	"./square/wf.svg": 2020,
	"./square/ws.svg": 2021,
	"./square/xk.svg": 2022,
	"./square/xx.svg": 2023,
	"./square/ye.svg": 2024,
	"./square/yt.svg": 2025,
	"./square/za.svg": 2026,
	"./square/zm.svg": 2027,
	"./square/zw.svg": 2028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1762;